import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FormData } from '../../../contexts/interfaces';
import { useRoutesContext } from '../../../contexts/RoutesContext';
import { changeCheckedToDB } from '../../../scripts/dataHandlers';
import { convertDate } from '../../../utils/convertDate';
import classes from './DoctorApprovalList.module.css';

interface Props {
    applications: FormData[],
    setApplications: (val: FormData[]) => void
}

const DoctorApprovalList = ({ applications, setApplications }: Props) => {

    const { routes } = useRoutesContext();

    const { t } = useTranslation();

    const navigate = useNavigate();

    const changeChecked = (index: number, newStatus: boolean) => {
        const doChange = async () => {
            try {
                // Change checkedStatus to DB
                index !== undefined && applications[index].formId && await changeCheckedToDB(applications[index].formId, newStatus)

                // Copy array of forms into updatedApplications
                const updatedApplications = [...applications];

                // Change checkedStatus of correct form
                updatedApplications[index].checkedStatus = newStatus;

                // Update applications in state with new updatedApplications -array
                setApplications([...updatedApplications]);
            } catch (err) {
                console.log(err);
            }
        };
        index !== undefined && applications[index].formId && doChange();
    };

    return (
        <div className={classes.container}>
            <div className={classes.doctorFormsWaitingTitle}>
                {t('doctorApprovalList.applicationsWaitingForApproval')}
            </div>
            <table className={classes.table}>
                <tbody>
                    <tr>
                        <th>
                            {t('doctorApprovalList.sent')}
                        </th>
                        <th>
                            {t('doctorApprovalList.name')}
                        </th>
                        <th>
                            {t('doctorApprovalList.title')}
                        </th>
                        <th>
                            {t('doctorApprovalList.registerNumber')}
                        </th>
                        <th>
                            {t('doctorApprovalList.checkedStatus')}
                        </th>
                        <th
                            className={classes.centered}
                        >
                            {t('doctorApprovalList.action')}
                        </th>
                    </tr>
                    {/* Go through every employee from resultsArray and render new row into the table */}
                    {applications && applications.length > 0 ? applications.map((application, i) => {
                        return (
                            <tr
                                key={i}
                                className={classes.tableApplicationRow}
                            >
                                <td>
                                    {application?.sentAt ? convertDate(application.sentAt) : "N/A"}
                                </td>
                                <td className={classes.bolded}>
                                    {application.firstName} {application.lastName}
                                </td>
                                <td>
                                    {application.educationLevel}
                                </td>
                                <td>
                                    {application.registerNumber}
                                </td>
                                <td className={classes.checkBoxContainer}>
                                    <input
                                        className={classes.checkbox}
                                        type="checkbox"
                                        checked={application.checkedStatus}
                                        onChange={() => changeChecked(i, !application.checkedStatus)}
                                    />
                                </td>
                                <td
                                    className={classes.centered}
                                >
                                    <button
                                        className={classes.toApprovalButton}
                                        onClick={() => navigate(`/${routes.doctorApproval}/${application.employeeId}/${application.formId}`)}
                                    >
                                        {t('doctorApprovalList.continueToApprovalButton')}
                                    </button>
                                </td>
                            </tr>
                        )
                    })
                        :
                        <tr>
                            <td>
                                <div className={classes.noResultsText}>
                                    {t('doctorApprovalList.noResultsText')}
                                </div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    );
};

export default DoctorApprovalList;